var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PmwParagraph',{staticClass:"check-item",attrs:{"size":"paragraph-40","weight":"light"}},[_vm._t("default"),(_vm.checked)?_c('Icon',{staticClass:"check-item--icon",attrs:{"icon":'check-circle'}}):_c('span',{staticClass:"check-item--empty"},[_vm._v("-")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }